import './style.scss'

import React from 'react'

import eightDLogo from '../../assets/img/partners/eightd-fits-cargo-color.png'
import flightModeAviationLogo from '../../assets/img/partners/flight-mode-aviation-color.png'
import flyKhivaLogo from '../../assets/img/partners/fly-khiva-color.png'
import haywaysCargoLogo from '../../assets/img/partners/hayways-cargo-color.png'
import kapKGLogo from '../../assets/img/partners/kap-kg-color.png'
import myFreighterLogo from '../../assets/img/partners/my-freighter-color.png'
import pattayaLogo from '../../assets/img/partners/pattaya-airways-color.png'
import skyVisionLogo from '../../assets/img/partners/sky-vision-airlines-color.png'
import skyGuardLogo from '../../assets/img/partners/skyguard-color.png'
import stellaviaLogo from '../../assets/img/partners/stellavia-color.png'

const partnerLogos = [
    {
        name: 'My Freighter', image: myFreighterLogo, className: 'section-partners__logo_my-freighter', width: 273, height: 273,
    },
    {
        name: 'Fly Khiva', image: flyKhivaLogo, className: 'section-partners__logo_fly-khiva', width: 287, height: 84,
    },
    {
        name: 'Kap.KG Aircompany', image: kapKGLogo, className: 'section-partners__logo_kap', width: 287, height: 93,
    },
    {
        name: 'Hayways Cargo', image: haywaysCargoLogo, className: 'section-partners__logo_hayways', width: 287, height: 166,
    },
    {
        name: 'Flight Mode Aviation', image: flightModeAviationLogo, className: 'section-partners__logo_flight-mode', width: 287, height: 107,
    },
    {
        name: 'Pattaya Airways', image: pattayaLogo, className: 'section-partners__logo_pattaya', width: 287, height: 177,
    },
    {
        name: 'SkyGuard', image: skyGuardLogo, className: 'section-partners__logo_skyguard', width: 231, height: 209,
    },
    {
        name: 'Stellavia', image: stellaviaLogo, className: 'section-partners__logo_stellavia', width: 122, height: 25,
    },
    {
        name: 'EightD by Fits Cargo', image: eightDLogo, className: 'section-partners__logo_eightd', width: 287, height: 114,
    },
    {
        name: 'Sky Vision Airlines', image: skyVisionLogo, className: 'section-partners__logo_sky-vision', width: 287, height: 204,
    },
]

const PartnerLogoList = ({ isDuplicate = false }: { isDuplicate?: boolean }) => (
    <ul className="section-partners__list" aria-hidden={isDuplicate || undefined}>
        {partnerLogos.map((logo) => (
            <li className="section-partners__item" key={logo.name}>
                <img
                    className={`section-partners__logo ${logo.className}`}
                    src={logo.image}
                    alt={isDuplicate ? '' : logo.name}
                    width={logo.width}
                    height={logo.height}
                    loading="lazy"
                    decoding="async"
                />
            </li>
        ))}
    </ul>
)

export const SectionPartners = () => (
    <section className="section-partners" aria-label="Partner airlines and operators">
        <div className="section-partners__container">
            <h2 className="section-partners__title">Cargo airlines and operators on World Trans Air</h2>
            <div className="section-partners__viewport">
                <div className="section-partners__track">
                    <PartnerLogoList />
                    <PartnerLogoList isDuplicate />
                    <PartnerLogoList isDuplicate />
                </div>
            </div>
        </div>
    </section>
)
